import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { useState, useEffect, useCallback } from "react"

import withEngravings from "areas/product/hoc/with-engravings"
import { forcePanelIndex } from "areas/product/store/actions"
import { useEngravingsValidation } from "areas/product/wizard-validation"
import {
  StyledButton,
  ButtonWrapper,
} from "components/HalfModal/hm-styled-components"
import Modal, { closeModal } from "components/modal"
import { retry, jewlr_t } from "helpers/application"

const Engravings = loadable(() =>
  retry(() => import("areas/product/wizard-options/engravings"))
)
const FontAwesomeIcon = loadable(() =>
  retry(() => import("components/font-awesome-icon"))
)

const EngravingsHalfModal = ({
  addToCart,
  data,
  isAddingToCart,
  choices,
  pref,
}) => {
  if (!data || data.disabled) return ""
  const [loading] = useState(false)
  const [label, setLabel] = useState("ENTER NAME OR TEXT")
  const [isValid] = useEngravingsValidation(data.engravings, choices)

  const [showContent, setShowContent] = useState(false)
  const afterShow = useCallback(() => {
    setShowContent(true)
  })

  useEffect(() => {
    if (data && data.engravings.length > 0) {
      if (data.engravings[0].title) {
        setLabel(data.engravings[0].title)
      }
    }
  }, [])

  return (
    <Modal
      afterShow={afterShow}
      contentStyle={{
        pb: 4,
        pt: 4,
      }}
      headerStyle={{ mb: 0 }}
      height="fit-content"
      label={label}
      labelStyle={{
        textTransform: "capitalize",
      }}
      onClose={() => {
        forcePanelIndex(pref)
        closeModal()
      }}
      show={`#engravings${pref !== "ef" ? pref : ""}`}
      variant="squircle"
      width="508px"
    >
      {showContent && <Engravings modal pref={pref} />}
      {showContent && (
        <ButtonWrapper>
          <StyledButton
            disabled={!isValid}
            loading={isAddingToCart}
            onClick={(e) => {
              if (!loading) {
                addToCart(e, isAddingToCart)
              }
            }}
            selected={true}
            variant="primary"
          >
            <div>
              Proceed to {jewlr_t("Cart")}{" "}
              {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : ""}
            </div>
          </StyledButton>
        </ButtonWrapper>
      )}
    </Modal>
  )
}

EngravingsHalfModal.propTypes = {
  addToCart: PropTypes.func,
  choices: PropTypes.object,
  data: PropTypes.object,
  isAddingToCart: PropTypes.bool,
  pref: PropTypes.string,
}

export default withEngravings(EngravingsHalfModal)
